// extracted by mini-css-extract-plugin
export var accordion = "_i6-0";
export var chevron = "_i6-3";
export var closed = "_i6-2";
export var content = "_i6-4";
export var open = "_i6-1";
export var rotate = "_i6-5";